import Service from "../../Services"
import { inflateSync } from "zlib"
import { Buffer } from "buffer"

const About = {
    namespaced : true,
    state : {
        form : null,
        about : [],
        news: [],
        newsById: null,
        network: [],
        partner: [],
        sponsor: [],
        contact: null,
        location: null,
        service_menu: null,
        about_main: null
    },
    mutations : {
        GET_ABOUT_BY_ID : (state,res)=>{
            state.form = res;
        },
        GET_ABOUT_ALL_MENU : (state,res)=>{
            state.news = res.news;
            state.partner = res.partner;
            state.sponsor = res.sponser_program;
            state.about = res.about;
            state.network = res.network;
            state.location = res.location;
            state.service_menu = res.service_menu;
            state.contact = res.contact;
            state.about_main = res.about_main;
        },
        setNewsByBranch: (state, res) => {
            state.news = res;
        },
        setNewsById: (state, res) => {
            state.newsById = res;
        },
    },
    actions : {
        getAboutAllMenu({commit},{branch_id, lang}) {
            return Service.AboutAPI.getAboutAllMenu(branch_id, lang).then(res => {
                // console.log('before ', res)
                let decompressed = inflateSync(Buffer.from(res, 'base64')).toString()
                res = JSON.parse(decompressed)
                // console.log('after ', res)
                commit('GET_ABOUT_ALL_MENU', res);
            });
        },
        // eslint-disable-next-line no-unused-vars
        getAboutAll({commit},lang='en') {
            return Service.AboutAPI.getAboutAll(lang);
        },
        // eslint-disable-next-line no-unused-vars
        getAboutById({commit}, {id,lang}) {
            return Service.AboutAPI.getAboutById(id,lang);
        },
        setFormAbout({commit},res){
            commit('GET_ABOUT_BY_ID',res);
        },
        getAboutNewsByBranch({commit}, {id,lang}) {
            return Service.AboutAPI.getAboutNewsByBranch(id,lang).then(res => {
                if (res) {
                    commit('setNewsByBranch', res);
                }
            })
        },
        getAboutNewsByPage({commit}, {id,page}) {
            return Service.AboutAPI.getAboutNewsByPage(id,page).then(res => {
                if (res) {
                    commit('setNewsByBranch', res);
                }
            })
        },
        getAboutNewsById({commit}, {id, lang}) {
            return Service.AboutAPI.getAboutNewsById(id, lang).then(res => {
                if (res) {
                    commit('setNewsById', res);
                }
            })
        },
    },
}
export default About
